'use client';
import { createSplitProps } from '../create-split-props.mjs';

function splitPresenceProps(props) {
  return createSplitProps()(props, [
    "lazyMount",
    "onExitComplete",
    "present",
    "unmountOnExit"
  ]);
}

export { splitPresenceProps };
